import $ from 'jquery';

class SpHeaderMenu {
  constructor() {
    this.FADE_SPEED_MS = 150;
    this.IS_OPEN_CLASS = 'is-open';

    this.$menu = $('#js-sp-menu');

    this.$menuOpenBtn = $('#js-sp-menu-open-btn');
    this.$menuCloseBtn = $('#js-sp-menu-close-btn');

    this.isOpen = false;

    if (this.$menu.length > 0) {
      this.init();
      this.addEvent();
    }
  }

  init() {
    this.$menu.css({ display: 'none' });
  }

  addEvent() {
    this.$menuOpenBtn.on('click', () => this.openMenu());

    this.$menuCloseBtn.on('click', () => this.closeMenu());
  }

  openMenu() {
    if (this.isOpen) {
      return;
    }

    this.$menu.addClass(this.IS_OPEN_CLASS);
    this.isOpen = true;

    this.$menu.fadeIn(this.FADE_SPEED_MS);
  }

  closeMenu() {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;

    this.$menu.fadeOut(this.FADE_SPEED_MS, () => {
      this.$menu.removeClass(this.IS_OPEN_CLASS);
    });
  }
}

export default SpHeaderMenu;
